import Whoops from '../components/Whoops';

export default function NoMach() {
    return <Whoops status={404} />;
}
